import type { ExtractPropTypes, PropType } from 'vue'
import type _DateButtonGroup from './date-button-group.vue'

type IDateBtnType = 'day' | 'week' | 'month' | 'year'

export const sdDateButtonGroupProps = {
    type       : { type: String as PropType<IDateBtnType>, default: 'day' }, // 日期按钮类型
    disabled   : { type: Boolean                         , default: false }, // 禁用按钮
}

export const sdDateButtonGroupEmits = [
    'click',

    'prev_year',
    'curr_year',
    'next_year',

    'prev_month',
    'curr_month',
    'next_month',

    'prev_week',
    'curr_week',
    'next_week',

    'prev_day',
    'curr_day',
    'next_day',
]

export type SdDateButtonGroupProps    = ExtractPropTypes<typeof sdDateButtonGroupProps>
export type SdDateButtonGroupInstance = InstanceType<typeof _DateButtonGroup>
